import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PublicReportPage from '../PublicReportPage/PublicReportPage';
import PublicLayout from '../PublicLayout/PublicLayout';
import PublicOrderPage from '../PublicOrderPage/PublicOrderPage';
import PublicQuotePage from '../PublicQuotePage/PublicQuotePage';
import PublicQuotePaymentPage from '../PublicQuotePaymentPage/PublicQuotePaymentPage';
import OrderAndQuoteSearchPage from '../OrderAndQuoteSearchPage/OrderAndQuoteSearchPage';
import PublicOrderPaymentPage from '../PublicOrderPaymentPage/PublicOrderPaymentPage';
import PublicDeviceDetailsPage from '../PublicDeviceDetails/PublicDeviceDetailsPage';
import FreeTrialLoginPage from '../FreeTrialLogin/FreeTrialLoginPage';
import OneTimeLoginPage from '../FreeTrialLogin/OneTimeLoginPage';
import PublicDashboardPage from '../PublicDashboardPage/PublicDashboardPage';

function PublicPage() {
  return (
    <PublicLayout>
      <Switch>
        <Route path="/p/dashboard/:publicToken" exact>
          <PublicDashboardPage />
        </Route>
        {/* fix link in RedirectToGatewayPage when uncommenting this chunk. */}
        {/* should redirect to /p/gateway. */}
        {/* <GatewayLayout> */}
        {/*   <Route */}
        {/*     path="/p/gateway" */}
        {/*   > */}
        {/*     <GatewayPage /> */}
        {/*   </Route>  */}
        {/* </GatewayLayout> */}
        <Route
          path="/public/report/:publicReportHashKey"
          render={(routeProps) => {
            const { match: actionMatch } = routeProps;
            const { publicReportHashKey } = actionMatch.params;
            return (
              <PublicReportPage
                publicReportHashKey={publicReportHashKey}
              />
            );
          }}
        />
        <Route
          path="/p/quote/:id"
          exact
        >
          <PublicQuotePage />
        </Route>
        <Route
          path="/p/order/:id"
          exact
        >
          <PublicOrderPage />
        </Route>
        <Route
          path="/p/quote/pay-as-guest/:id"
          exact
        >
          <PublicQuotePaymentPage />
        </Route>
        <Route
          path="/p/order/pay-as-guest/:id"
          exact
        >
          <PublicOrderPaymentPage />
        </Route>
        <Route
          path="/p/order-quote/search"
          exact
        >
          <OrderAndQuoteSearchPage />
        </Route>

        <Route path="/p/device/:publicPageHash">
          <PublicDeviceDetailsPage />
        </Route>
        <Route path="/p/free-trial/login/:sid/:em/:hash" component={OneTimeLoginPage} />
        <Route path="/p/free-trial/:sid/:em" component={FreeTrialLoginPage} />
      </Switch>
    </PublicLayout>
  );
}

export default PublicPage;
